export type Path = "/" | "/auth/login"

export const HOME_PAGE: Path = "/"
export const LOGIN_PAGE: Path = "/auth/login"
